/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, themeV2, coloredScrollBar } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '.publishmodal': {
      textAlign: 'center',
      overflowY: 'auto',
      extend: coloredScrollBar(themeV2.color.base.scrollbar),
      fontSize: pxToEm(14),
      padding: pxToEm(14),
      '& button': { width: '100%'},
      '& h4': {
        marginBottom: pxToEm(20),
        fontSize: '20px'
      },
      '& .changelist': {
        textAlign: 'left',
        margin: `${pxToEm(16)} ${pxToEm(24)}`,
      },
      '& ul': {
        margin: pxToEm(8),
        marginBottom: pxToEm(16),
        color: themeV2.color.base.gray.dark,
        '& li': {
          textAlign: 'left',
          marginLeft: pxToEm(16)
        }
      }
    }
  },
  productmanagerpage: {
    '& .configv2controller.opened-true': {
      background: '#fff', // ensure the header has a background so as elements scroll beneath it they remain invisible
      position: 'sticky', // keep header element sticky so user can always see what section of the config they are in
      top: '-60px',
      zIndex: '1000' // make sure to keep the header over top of whatever elements are scrolling beneath it,
    },
   '& .pageheader': {
    maxWidth: pxToEm(1280)
   },
   '& .actionbuttons': {
    display: 'flex',
    alignItems: 'center',
    gap: pxToEm(8)
   },
   '& .disabled-true': {
    opacity: 0.5,
    pointerEvents: 'none'
   },
   '& .globalsave': {
    position: 'sticky',
    background: '#fff',
    bottom: 0,
    width: '100%',
    padding: '24px',
    boxShadow: '0em 0em 1.5em rgba(172, 217, 251, 0.2)',
    zIndex: 999,
    width: '100%',
    borderTop: '1px solid #EDEDED'
  }
  }
});
